import React from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import PropTypes from 'prop-types'
import { useStyles, MenuPaper } from '../styles'

const Source = ({ selectedValue, options, onChange, label, labelId, ...rest }) => {
  const classes = useStyles()

  return (
    <FormControl
      variant="outlined"
      margin="dense"
      className={classes.formControl}
    >
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={selectedValue}
        onChange={onChange}
        label={label}
        fullWidth
        MenuProps={{
          PaperProps: {
            component: MenuPaper,
            elevation: 0
          },
        }}
        {...rest}
      >
        {options.map((option) => (
          <MenuItem
            key={option.uuid}
            value={option.uuid}
            disabled={option.disabled}
          >
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
Source.propTypes = {
  selectedValue: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string.isRequired,
      name: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
      ]).isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]).isRequired,
  labelId: PropTypes.string.isRequired,
}

export default Source
